export default "__VITE_ASSET__BXiu35v0__"